// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3LGFB","footer":"ModalError_footer__2fuJG"};